// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__k7rWz","file":"styles_file__mf3qy"};